// Klein info-icoontje met een uitlegtekst — verschijnt als browser-tooltip
// (native `title`) en is zichtbaar markeerbaar met een vraagteken.

import { HelpCircle } from "lucide-react";

interface Props {
  text: string;
  className?: string;
}

export function InfoBadge({ text, className }: Props) {
  return (
    <button
      type="button"
      title={text}
      aria-label={text}
      className={
        "inline-flex items-center text-muted-foreground hover:text-foreground " +
        (className ?? "")
      }
      onClick={(e) => e.preventDefault()}
    >
      <HelpCircle size={12} />
    </button>
  );
}
